export default __webpack_public_path__ + "static/media/Clasp of the Howling Giant.d80a8b6f.jpg";